module.exports = __webpack_public_path__ + "img/library_sound.04b78636.svg";